export const ExperienceConfig = [
    {
        company: "YOURICSOFT PVT. LTD.",
        period: "Jan 2020 - Apr 2020",
        url: "https://youricsoft.com",
        positions: [
            {
                position: "SOFTWARE INTERN",
                description: "> we developed an application which is used to manage the internship candidate data and provide the to interact with Provider,Employer and Candidate"+
                 "\n> That manages the candidate screening process and share the same profile with employer so employer can review the candidate and schedule the interview and provide the feedback to the Provider.\n"
                 
            }
        ]
    },
    {
        company: "ACM PCCOE Student Chapter",
        period: "Jun 2019 - Current",
        url: "http://pccoe.acm.org",
        positions: [
            {
                position: "WEBMASTER",
                description: ">Created and Managed PCCOE ACM Student Chapter’s website and contributed in winning Runner up award for best student chapter award in India from ACM india."                
            }
        ]
    }
]